import React from "react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

const Hackathon = () => {
  return (
    <Layout>
      <div className="slider-area">
        <div className="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-center ">
              <div className="col-xxl-12">
                <div className="hero-caption hero-caption2">
                  <br />
                  <br />
                  <h2>Registration - Hackathon</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="container p-4 pt-0 mt-0">
        <div className="row">
          <div className="col">
            <Link
              to="/register/hackathon/step-two/individual"
              className="btn-yellow text-dark w-100"
              style={{
                height: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <i
                style={{ fontSize: "150px", marginBottom: "40px" }}
                className="fab fa-facebook"
              ></i>
              <h4>Individual</h4>
            </Link>
          </div>
          <div className="col">
            <Link
              to="/register/hackathon/step-two/team"
              className="btn-yellow  w-100"
              style={{
                height: "300px",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <i
                style={{ fontSize: "150px", marginBottom: "40px" }}
                className="fab fa-facebook"
              ></i>
              <h4>Team Up</h4>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Hackathon;
